export const chartdir = [
    // { name: "单列显示", value: "5" },
    // { name: "双列显示", value: "6" },
    // { name: "纵向显示", value: "7" },
    { name: "向下展开", value: "1" },
    { name: "向左展开", value: "4" },
    { name: "向上展开", value: "3" },
    { name: "向右展开", value: "2" },
]